import {workAttrList} from "../../workdb/types/workForm";
import useFetchAllQuery from "../../../hooks/useFetchAllQuery";
import {findWork, FindWorkResponseData} from "../../../utils/awsAmplifyUtil";

export interface UseWorkClassParams {
  keyword: string;
  enableAutoFetch?: boolean;
}

export default function useWorkClass(params: UseWorkClassParams) {
  return useFetchAllQuery<FindWorkResponseData<'class'>>({
    queryFn: (query) => findWork(
      'class',
      {
        version: "work-user",
        queryAttr: params.keyword === ""
          ? {}
          : {
            $or: [
              {[workAttrList.nameJp.key]: {"$regex": params.keyword, "$options": "i"}},
              {[workAttrList.nameEn.key]: {"$regex": params.keyword, "$options": "i"}},
              {[workAttrList.code.key]: {"$regex": params.keyword, "$options": "i"}},
              {[workAttrList.manufacturer.key]: {"$regex": params.keyword, "$options": "i"}},
            ]
          },
      },
      query
    ),
    needToFetchMore: (data, limit) => Object.entries(data?.items ?? {}).length === limit,
    enableAutoFetch: params.enableAutoFetch,
  });
}
